import SkeletonLoader from './index';

const LessonStudentDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-10 w-full">
      {/* Header Profile Section */}
      <div className="flex flex-col items-center gap-4 w-full">
        {/* Avatar */}
        <SkeletonLoader variant="circle" width={100} height={100} />
        {/* Name */}
        <SkeletonLoader width={200} height={32} />

        {/* Age & Gender Row */}
        <div className="flex items-center justify-center gap-8 w-full">
          <SkeletonLoader width={80} height={20} />
          <SkeletonLoader width={80} height={20} />
        </div>
      </div>

      {/* Student Details Grid (matches the 2-column grid in Modal) */}
      <div className="grid grid-cols-2 gap-y-6 gap-x-12 w-full">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="flex items-start gap-3">
            {/* Icon */}
            <SkeletonLoader variant="circle" width={20} height={20} />
            <div className="flex flex-col gap-1 flex-1">
              {/* Label */}
              <SkeletonLoader width={80} height={14} />
              {/* Value */}
              <SkeletonLoader width={120} height={20} />
            </div>
          </div>
        ))}
      </div>

      {/* Progress Summary Section */}
      <div className="flex flex-col gap-4 w-full">
        {/* Title */}
        <SkeletonLoader width={150} height={24} />

        <div className="rounded-2xl border border-neutral-light-200 p-4 space-y-4">
          {/* Overall Progress Header */}
          <div className="flex justify-between items-center">
            <SkeletonLoader width={120} height={20} />
            <SkeletonLoader width={40} height={20} />
          </div>

          {/* Progress Bar */}
          <SkeletonLoader height={8} className="rounded-full w-full" />

          {/* 3 Summary Cards */}
          <div className="flex gap-4">
            {[1, 2, 3].map((_, index) => (
              <div key={index} className="flex-1 h-20">
                <SkeletonLoader height="100%" className="rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Activity Timeline Section */}
      <div className="flex flex-col gap-4 w-full">
        {/* Title */}
        <SkeletonLoader width={150} height={24} />

        <div className="flex flex-col gap-6">
          {[1, 2, 3].map((_, index) => (
            <div key={index} className="flex items-center gap-4">
              {/* Content */}
              <div className="flex flex-1 items-center justify-between">
                <SkeletonLoader width={180} height={35} />
                <SkeletonLoader width={60} height={16} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LessonStudentDetailsSkeleton;
